export const SMALL_THRESHOLD = '600px';
